import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { el } from 'date-fns/locale';
import { IDashExam, IExam, SendEmailMessage } from 'src/app/interface/dto';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { QuillEditorComponent } from 'ngx-quill'
import { examDefault } from 'src/app/interface/dtoDefaults';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { Util } from 'src/app/services/Util';
import { take } from 'rxjs';
import { GenericConfirmComponent } from 'src/app/shared-layout/generic-confirm/generic-confirm.component';
import { PopoverService } from 'src/@vex/components/popover/popover.service';

@Component({
  selector: 'app-email-messages',
  templateUrl: './email-messages.component.html',
  styleUrls: ['./email-messages.component.scss']
})
export class EmailMessagesComponent implements OnInit {

  matricNoList = "";
  sendEmailMessageData: SendEmailMessage = {
    message: '',
    emailSubject: '',
    examNoList: [],
    sendLoginLink: false,
    sendSEBLink: false,
    sendExaminationTimeTable: false,
    examId: 0
  }
  // Selected exam
  selectedExam: IExam = null;
  mode: any;
  defaultMessage: string = ""
  quill: any = {};
  recipientCount = 0;
  @ViewChild('editor') editor: QuillEditorComponent;


  constructor(private candidateService: CandidateService, private snackBar: SnackbarService, private examService: ExamService, private route: ActivatedRoute,private popoverService: PopoverService,) {
  }

  async ngOnInit() {
    const clearGridSelection = GridUtil.getGridSelection();
    if (this.examService.selectedExams && this.examService.selectedExams?.length > 0 && !clearGridSelection) {
      this.selectedExam = this.examService.selectedExams[0];
    }
    this.route.queryParams.subscribe(params => {
      this.mode = params['mode'] || '';
    });
    await this.candidateService.defaultEmailMessage(this.mode == 'default').then((res: any) => {
      this.defaultMessage = res.message;
      this.sendEmailMessageData.message = res.message;
      this.sendEmailMessageData.emailSubject = res.emailSubject;
    });
    // get default message
    this.editor.quillEditor.clipboard.dangerouslyPasteHTML(this.defaultMessage);
  }
  async ngAfterViewInit() {
    this.editor.onEditorCreated.subscribe(() => {
      this.editor.quillEditor.clipboard.dangerouslyPasteHTML(this.defaultMessage);
    });
  }
  async confirmRecipientCount(origin: any) {
    this.sendEmailMessageData.examNoList = this.matricNoList
      .split(/[\s,]+/) // Split by commas, spaces, newlines, and carriage returns
      .filter(entry => entry.trim().length > 0); // Remove empty entries

    if (this.sendEmailMessageData.examNoList.length === 0) {

      if (this.selectedExam) {
        this.recipientCount =  (await this.examService.getExamScheduleCount(this.selectedExam.id)).data;
      } else {
        this.recipientCount =  (await this.candidateService.getCandidateCount()).data;
      }
    } else {
      this.recipientCount = this.sendEmailMessageData.examNoList.length;
    }

    const popover = this.popoverService.open({
        content: GenericConfirmComponent,
        origin: origin,
        width: 2000,
        offsetY: 12,
      data: { message: `Confirm that you want to email ${this.recipientCount} recipients ${this.selectedExam?.id > 0 ? `scheduled for the exam ${this.selectedExam.examinationName}` : ''}?` },
        position: [
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'top'
          }
        ]
      });

      popover.afterClosed$
        .pipe(take(1))
        .subscribe((result: any) => {
          if (result?.data === true) {
            this.sendEmail();
          }
        });

  }
  async sendEmail() {

    if (this.selectedExam) {
      this.sendEmailMessageData.examId = this.selectedExam.id;
    }
    try {

      await this.candidateService.sendCandidateEmail(this.sendEmailMessageData);
      this.snackBar.success('Message Sent Successfully');

    } catch (error) {
      this.snackBar.error(error);
      console.log(error, "error sending message");
    }
  }
  customSearchFn(term: string, item: any): boolean {
    const termLower = term.toLowerCase();
    return (
      item.examinationName.toLowerCase().includes(termLower) ||
      item.id.toString().includes(termLower)
    );
  }
  toast = {
    visible: false,
    x: 0,
    y: 0
  };

  copyPlaceholder(text: string, event: MouseEvent) {
    navigator.clipboard.writeText(text);
    // Insert into Quill at cursor position
    this.insertIntoQuill(text);
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();

    // Position toast beside the span
    this.toast.x = rect.right + 10; // 10px to the right
    this.toast.y = rect.top;

    this.toast.visible = true;

    // Hide after 1.2 seconds
    setTimeout(() => {
      this.toast.visible = false;
    }, 1200);
  }
  onEditorReady(quill: any) {
    this.quill = quill;
  }
  insertIntoQuill(text: string) {
    if (!this.quill) return;

    const range = this.editor.quillEditor.getSelection(true);

    if (range) {
      // Insert text at cursor
      this.editor.quillEditor.insertText(range.index, text);

      // Move cursor to end of inserted text
      this.editor.quillEditor.setSelection(range.index + text.length, 0);
    } else {
      // If no cursor (editor not focused), append at end
      const length = this.editor.quillEditor.getLength();
      this.editor.quillEditor.insertText(length, text);
    }
    this.sendEmailMessageData.message = this.quill.root.innerHTML;
    console.log(this.sendEmailMessageData, "data");

  }

  async saveDraft() {
    try {
      if (
        !this.sendEmailMessageData.emailSubject &&
        Util.isQuillEmpty(this.sendEmailMessageData.message)
      ) {
        this.snackBar.error('No draft to save');
        return;
      }
      let data = {
        message: this.sendEmailMessageData.message,
        emailSubject: this.sendEmailMessageData.emailSubject,
      }
      console.log(data, "draft data");

      await this.candidateService.saveEmailDraft(data);
      this.snackBar.success('Draft Saved Successfully');

    } catch (error) {
      this.snackBar.error(error);
      console.log(error, "error saving draft");
    }
  }
}
